import $ from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';
import EFOcats_branch_equal from '../branch/efocats_branch_equal.js';
import EFOcats_import_html from '../import/efocats_import_html.js';
import EFOcats_import_lang from '../import/efocats_import_lang.js';

/**
 * ページ遷移クリックイベント
 */
export default class EFOcats_event_page extends EFOcats_event_core {
  /**
   * コンストラクタ
   * @param validations エラーチェック処理配列
   */
  constructor() {
    super();
    this.allQa = 0;
    this.mater = 0;

    this.brachChecker = {
      equal: new EFOcats_branch_equal(),
    };

    // 先頭ページに戻るボタンを作成するか
    this.pager_back = false;

    // 先頭ページの戻るボタンをクリックした時に元画面のどのボタンをクリックするか
    this.pager_back_selector = '';

    // 先頭ページの戻るボタンをクリックした時の遷移先URL
    this.pager_back_url = '';
  }

  /**
   * イベントための事前の仕込み
   */
  init() {
    this.allQa = this.$('.qa').length;
    this.$('.all-num').text(this.allQa);
    this.mater = (1 / this.allQa) * 100;
    // 開始ページがない時
    if (this.$('.startPage').length <= 0) {
      this.$('.now-num').text(1);
    }

    this.$('section').eq(0).addClass('action');

    // ボタン作成
    this.createPager();

    // 可変対策
    this.$('.cat-wrapper').height(this.$('body').height());
    this.$('.cat-section--border .container').each((index, element) => {
      $(element).height($(element).outerHeight()).css('position', 'absolute');
    });

    this.branch();

    this.process();

    this.addTabIndex();

    // 他のページの非表示をセット
    this.$('section:not(".action")').addClass('noaction');
  }

  /**
   * ページ遷移ボタンの作成
   * @param {*} number
   * @param {*} tmp
   * @param {*} elem
   */
  createPager() {
    for (let number = 0; number < this.$('.cat-section').length; number++) {
      const page = this.$('.cat-section').eq(number);

      if (number === 0) {
        // 開始ページの場合
        this.createPager_startpage(page);
      } else {
        // qaの場合
        this.createPager_qapage(page);
      }
    }

    // 送信ボタン生成
    if (this.$('.checkPage').length === 0) {
      this.$('body')
        .find('.cat-section:last-child')
        .find('.pager')
        .html(EFOcats_import_html.getValue('btn_submit', {label: EFOcats_import_lang.getValue('確認')}));
    }
  }

  /**
   * ページ遷移ボタンの作成（開始ページ以外）
   * @param {*} page
   */
  createPager_qapage(page) {
    page.find('.container').append(EFOcats_import_html.getValue('btn_pager'));
  }

  /**
   * ページ遷移ボタンの作成（開始ページ）
   * @param {*} page
   */
  createPager_startpage(page) {
    if (this.pager_back) {
      page.find('.container').append(EFOcats_import_html.getValue('btn_pager'));
    } else {
      page.find('.container').append(EFOcats_import_html.getValue('btn_startpage_next'));
    }
  }

  /**
   * イベント本体をセット
   */
  event() {
    this.$('body').on('click.click', '.cat-pager-btn', event => {
      const element = event.currentTarget;
      // 複数name修正？？
      const obj = $(element).parents('section').find('input,select,textarea');
      this.variable(this.get_variable_id(), obj);

      this.branch();

      if ($(element).hasClass('prev-btn')) {
        // 戻るボタンの場合
        this.back(element);
      } else if ($(element).hasClass('next-btn')) {
        // 次へボタンの場合
        this.next(element, event);
      }

      this.addTabIndex();
    });
  }

  /**
   * 次へボタン
   * @param {*} element
   * @param {*} event
   */
  next(element, event) {
    // qaの場合にエラーチェックを行う
    if ($(element).parents('section').hasClass('qa')) {
      this.checkerror(element);
    }

    // go-flagを持っているか、オプションページの場合
    if ($(element).parents('section').hasClass('go-flag') || $(element).parents('section').hasClass('optionPage')) {
      this.slide_next(element, event);
    } else {
      // 他のページの非表示をセット
      this.$('section:not(".action")').addClass('noaction');
    }
  }

  /**
   * 次ページへの遷移
   * @param {*} element
   * @param {*} event
   */
  slide_next(element, event) {
    // 他のページの非表示を解除
    this.$('section').removeClass('noaction');

    const section = $(element).parents('.cat-section').nextAll('.cat-section').not('.hidden').eq(0);

    if (section.length === 0) {
      // 次のページが無い場合は送信処理へ
      efocats.submit.data_submit($(event.currentTarget));
    } else {
      // スライド
      const position = section[0].offsetTop;

      this.$('section').removeClass('action');
      section.addClass('action');

      this.slide(position);
      if ($(element).parents('section').hasClass('error')) {
        $(element).parents('section').removeClass('error');
      }
      this.pager();
    }
  }

  /**
   * エラーチェック
   * @param {*} element
   */
  checkerror(element) {
    // 2重エラー防止
    // go-flagを持っていない場合はエラーチェックを行う
    if (!$(element).parents('section').hasClass('go-flag') && !$(element).parents('section').hasClass('checked')) {
      // チェンジイベントでエラーが出ている場合はリターンする
      $(element)
        .parents('section')
        .find('input,textarea,select')
        .each((index, elem) => {
          // 既にエラーが表示されている場合はスキップ
          if ($(elem).parents('.check-flag').attr('data-error-text') && $(elem).parents('.check-flag').attr('data-error-text') !== '') {
            return;
          }

          efocats.validations.check_error($(elem));
        });
    }
    // checkedを外す
    $(element).parents('section').removeClass('checked');
  }

  /**
   * 戻るボタン
   * @param {*} element
   */
  back(element) {
    const index = this.$('.cat-section').index($(element).parents('.cat-section'));

    // 他のページの非表示を解除
    this.$('section').removeClass('noaction');

    if (index === 0) {
      this.startpage_back(element);
    } else {
      this.slide_back(element);
    }
  }

  /**
   * 開始ページの戻るボタンの処理
   * @param {*} element
   */
  startpage_back(element) {
    $(window).off('.attention');

    if (this.pager_back_selector !== '') {
      $(this.pager_back_selector)[0].click();
    } else if (this.pager_back_url !== '') {
      window.location.href = this.pager_back_url;
    } else {
      window.history.back();
    }
  }

  /**
   * 前ページへの遷移
   * @param {*} element
   */
  slide_back(element) {
    const position = $(element).parents('.cat-section').prevAll('.cat-section').not('.hidden').eq(0)[0].offsetTop;
    const section = $(element).parents('.cat-section').prevAll('.cat-section').not('.hidden').eq(0);

    this.$('section').removeClass('action');
    section.addClass('action');

    this.slide(position);

    this.pager();
  }

  /**
   * プログレスバーの更新
   */
  process() {
    const hidden_Alleq = this.$('.qa.hidden').length;
    const hidden_eq = this.$('.qa.action').prevAll('.qa.hidden').length;
    let eq = this.$('.qa.action').index() - hidden_eq + 1;

    // 開始ページがない時
    if (!this.$('.startPage').length > 0) {
      this.$('.navgater-num.hidden').removeClass('hidden');
    } else {
      eq -= 1;
    }

    if (eq > 0 && eq <= this.allQa) {
      this.$('.now-num').text(eq);
      this.$('.all-num').text(this.allQa - hidden_Alleq);
      this.mater = (eq / (this.allQa - hidden_Alleq)) * 100;
      this.$('.mater-bar').css('width', `${this.mater}%`);
    }
  }

  /**
   * 変数機能
   * @param {*} id
   * @param {*} target
   */
  variable(id, target) {
    const name = target.attr('name');
    const val = target.val();
    // ループ
    Object.keys(id).forEach(key => {
      if (key === name) {
        this.$(`.${key}`).html(val);
        if (val === '') {
          this.$(`.${key}`).html('_ _ _');
        }
      }
    });
  }

  /**
   * スライド処理
   * @param position
   */
  slide(position) {
    this.$('.cat-wrapper > .cat-container').animate(
      {
        scrollTop: position,
      },
      300,
      'swing',
      () => {
        this.focus_item();
      }
    );
  }

  /**
   * フォーカス
   */
  focus_item() {
    // 他のページの非表示をセット
    this.$('section:not(".action")').addClass('noaction');

    return true;
  }

  /**
   * ページ遷移
   */
  pager(section) {
    const obj = this.$('section.action');
    // optionPageの場合はプログレスバーを非表示、qaの場合はプログレスバーを表示
    if (obj.hasClass('optionPage')) {
      this.$('.navgater-num').addClass('hidden');
    } else if (obj.hasClass('qa')) {
      this.$('.navgater-num').removeClass('hidden');
    }

    if (this.$('.checkPage').length > 0) {
      this.check_btn_confirmation();
    }

    this.process();
  }

  /**
   * ボタンの言語置換
   */
  check_btn_confirmation() {
    const target = this.$('.qa:visible');
    const target_btn = target[target.length - 1];
    this.$('.qa').find('.next-btn').html(this.langagerList('次へ'));
    this.$(target_btn).find('.next-btn').html(this.langagerList('内容確認'));
  }

  /**
   * 変数機能
   */
  get_variable_id() {
    const name = {};

    this.$('.cat-txt').each((index, element) => {
      // spanで囲む
      if ($(element).html().indexOf('%_') !== -1) {
        if (!name[$(element).find('[data-variable="active"]').attr('class')]) {
          $(element)
            .find('[data-variable="active"]')
            .each(elem => {
              name[$(elem).attr('class')] = '';
            });
        }
      }
    });
    return name;
  }

  addTabIndex() {
    this.$('.cat-container').find('.box-label,.next-btn,input,textarea,select,button,a,iframe,div,label').attr('tabindex', '-1');

    this.$('.qa.action')
      .find('.box-label,.next-btn,input,textarea,select,.submit-btn')
      .each((index, elem) => {
        $(elem).attr('tabindex', index + 1);
      });
  }

  /**
   * 分岐判定
   */
  branch() {
    if (efocats.brachSetting) {
      for (let index = 0; index < efocats.brachSetting.length; index++) {
        const section = efocats.brachSetting[index];

        this.$('.qa').each((qaIndex, qa) => {
          if ($(qa).find(section.query).length > 0) {
            let hide = false;

            for (let condIndex = 0; condIndex < section.condition.length; condIndex++) {
              const condition = section.condition[condIndex];
              if (!this.brachChecker[condition.pattern].checkCondition(condition)) {
                hide = true;
              }
            }

            if (hide) {
              $(qa).addClass('hidden');
            } else {
              $(qa).removeClass('hidden');
            }
          }
        });
      }
    }
  }
}
